import Vue from 'vue';
import Vuex from 'vuex';
import http from './util/http';
import wx from "weixin-js-sdk";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    personInfo: {},// 个人信息
    footerShow: false, // 底部tab
    foooterName: '',// tab页路由名称
    config: '', // 网站配置
    loginparams: {},// 第一次登陆设置密码的手机号和验证码信息
    search_input: '', // 上次搜索
    search_question: '',//上次搜索问答
    search_history: [], // 搜索历史记录
    keywords: '',// 搜索title
    app: '',  // 'android', 'ios'
    back_normal: 0,   // 判断当前在app内打开的webview页面 页面点击返回按钮存在关闭webview的逻辑下是否需要不关闭而按照正常router返回上一级h5页面，现阶段主要用户一对一课程提交订单的时候点击返回关闭整个webview, 暂使用页面 OtoPlan 开启和关闭
    is_reset: 0, //是否初始化页面状态
    pay_address_id: '',
    classify: false,
    classify_name: '未选择'
  },
  mutations: {
    /**
     * 操作token
     *  */
    SET_USERINFO: (state, person) => {
      state.personInfo = person
    },
    /**
     * 设置分类id
     */
    SET_CLASSIFY: (state, classify) => {
      if (classify) {
        state.classify = true;
      } else {
        state.classify = false;
      }
      if (localStorage.classify_name) {
        state.classify_name = localStorage.classify_name;
      }
    },
    /**
     * 设置foot
     * @param {*} state
     * @param {String} name   路由
     */
    SET_FOOT (state, name) {
      if (name) {
        state.foooterName = name
        state.footerShow = true
      } else {
        state.foooterName = ''
        state.footerShow = false
      }
    },
    /**
     * 保存网站配置参数项
     * @param {Object} app 配置参数
     */
    SET_CONFIG (state, app) {
      state.config = app
    },
    /**
     * 用以第一次登陆设置密码的账号和验证码
     * @param {Object} params 手机号、验证码
     */
    GETLOGINPARAMS (state, params) {
      state.loginparams = params;
    },
    /**
     * 储存搜索文本内容
     * @param {String} inp
     */
    SEARCH_INP (state, inp) {
      // 添加上次搜索记录
      state.search_input = inp;
    },
    /**
     * 储存搜索问答内容
     * @param {String} search_question
     */
    SEARCH_QUS_INP (state, inp) {
      // 添加上次搜索记录
      state.search_question = inp;
    },
    /**
     * 清空搜索记录
     */
    SEARCH_EMPTY (state) {
      state.search_history = [];
    },
    /**
     * search页操作历史记录
     * @param {*} state
     * @param {最新记录} new_his
     */
    ADD_SEARCH_HISTORY (state, new_his) {
      // 添加搜索历史
      if (state.search_history.indexOf(new_his) != -1) {
        // 若搜索历史中已有该记录，则删除原纪录，添加新纪录到最前
        // 若没有。则直接添加
        var index = state.search_history.indexOf(new_his);
        state.search_history.splice(index, 1);
      }
      state.search_history.unshift(new_his);
      // 若历史记录为五个或更多时，删除最早的
      if (state.search_history.length > 5) {
        state.search_history.pop();
      }
    },
    /**
     * 设置app下的webview环境
     * @param {String} val
     */
    SET_APP (state, val) {
      state.app = val
    },
    /**
     * oto、考试等用以暂存搜索标题的值
     * @param {String} val 搜索值
     */
    OTO_KEY (state, val) {
      if (val) {
        state.keywords = val
      } else {
        state.keywords = ""
      }
    },
    /**
     * 在存在返回关闭webview和特殊情况不能不能关闭的页面
     * @param {*} flag
     */
    BACK_NORMAL (state, flag) {
      state.back_normal = flag
    },
    IS_RESET_STATE (state, flag) {
      state.is_reset = flag
    },
    SET_PAY_ADDRESS (state, id) {
      if (id) { state.pay_address_id = id } else { state.pay_address_id = "" }
    }
  },
  actions: {
    /**
     * 更新个人信息
     * @param {*} content
     */
    async getPerson (content) {
      let url = '/api/app/userInfo';
      if (localStorage.teacher_id) {//讲师
        url = '/api/lector/teacher/login/info'
      }
      const userInfo = await http.get(`${url}`)
      localStorage.user_id = userInfo.id
      content.commit('SET_USERINFO', userInfo)
    },
    /**
     * 异步凑/开团校验
     * @param {*} content
     * @param {Object} data 活动id, 团id(开团传0)
     */
    async CheckSpell(content, data) {
      let notice = await http.get(
        `/api/app/checkSpell/${data.spell_id}/${data.group_id ? data.group_id : 0}`
      );
      if (notice.code && notice.code == 203) {
        let data = JSON.parse(notice.msg);
        Toast({
          message: data.msg,
          duration: 1000
        });
        setTimeout(() => {
          router.push({
            name: "OrderDetail",
            query: {
              order_id: data.data.order_id,
              order_type: 5
            }
          });
        }, 1000);
        return false;
      } else {
        return true
      }
    },

    /**
     * 设置微信分享
     * @param {*} content
     * @param {Object} path  router to
     */
    async setShare(content, params) {
      // if (!pub.isWeiXin()) {
      //   return;
      // }
      // 默认配置
      let web_config;
      let excludeRoute = ["Index", "Course", "Record", "Practise", "Person", "StuQuestionAnswers", "MyStudy", "News", "BookList", "CheckIn", "Exam", "Exercise", "Group", "IntegralStore"]; // 排除一级页面 增加返回首页参数
      if (params.share_type == 1) {
        web_config = content.state.config;
      } else {
        web_config = params;
        if (!web_config.mobile_logo && content.state.config.mobile_logo) {
          web_config.mobile_logo = content.state.config.mobile_logo;
        }
        if (!web_config.web_description && content.state.config.web_description) {
          web_config.web_description = content.state.config.web_description;
        }
      }
      if (web_config.mobile_logo) {
        let config = await http.post(`/api/app/getWechatSign`, {
          url: "https://" + window.location.host + params.route.fullPath //必须加 https://
        });
        wx.config({
          // debug: true,
          appId: config.appId,
          timestamp: config.timestamp, // 必填，生成签名的时间戳
          nonceStr: config.noncestr, // 必填，生成签名的随机串
          signature: config.sign, // 必填，签名
          jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"] // 必填，需要使用的JS接口列表
        });
        wx.ready(() => {
          let link = "";
          if (excludeRoute.includes(params.route.name)) {
            link = config.url;
          } else {
            if (config.url.indexOf("?") != -1) {
              link = `${config.url}&share_source=1`;
            } else {
              link = `${config.url}?share_source=1`;
            }
          }
          // 朋友
          if (excludeRoute.includes(params.name)) {
            link = config.url;
          } else {
            if (config.url.indexOf("?") != -1) {
              link = `${config.url}&share_source=1`;
            } else {
              link = `${config.url}?share_source=1`;
            }
          }
          wx.onMenuShareAppMessage({
            title: web_config.web_title, // 分享标题
            desc: web_config.web_description, // 分享描述
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: web_config.mobile_logo, // 分享图标
            success() {
              // alert('设置成功')
            },
            fail() {
              // alert('分享失败')
            }
          });
          // 朋友圈
          wx.onMenuShareTimeline({
            title: web_config.web_title, // 分享标题
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: web_config.mobile_logo, // 分享图标
            success: function () {
              // alert('设置微信分享成功')
            }
          });
        });
      } else {
        setTimeout(() => {
          content.dispatch("setShare", params);
        }, 200);
      }
    },
    getClassify (content, id) {
      content.commit('SET_CLASSIFY', id);
    }
  },
});
